module.exports = __webpack_public_path__ + "img/ticket_logo.1de5ff86.webp";